export enum ExternalProjectSecretType {
  Success = 'success',
  QuotaExceeded = 'quota',
  Naf = 'naf'
}